import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useChargebeePortals } from "hooks/useChargebeePortals";


export function AutoOpenBillingAddressDialog() {
  const { openChargebeePortal } = useChargebeePortals();
  const navigate = useNavigate();

  useEffect(() => {
    openChargebeePortal("ADDRESS", { close: () => navigate("/billing") });
  }, [ openChargebeePortal, navigate ]);

  return <></>;
}
